{
  "hero": {
    "title": "Prices"
  },
  "intro": {
    "title": "Fast service, reasonable prices, great value!",
    "subtitle": "Unlike larger agencies, I offer a unique blend of affordability, personalized service, and specialized expertise in crafting videos tailored for modern platforms."
  },
  "promo": {
    "discount": "-50%",
    "title": "FOR THE FIRST CORPORATE OR RECRUITMENT VIDEO",
    "location": "*FILMING ONLY POSSIBLE IN MUNICH, GERMANY (+ 100KM).",
    "cta": "I'M INTERESTED"
  },
  "tabs": {
    "subscription": "Subscription",
    "perProject": "Per Project"
  },
  "subscription": {
    "intro": "Hire me as a full-stack videographer/designer/developer without the constraints of a contract.",
    "packages": {
      "essential": {
        "title": "1. Essential Package",
        "prices": "10-15 hours/month (€700–€1,000/month)",
        "deliverables": "Deliverables:",
        "items": [
          "VIDEOGRAPHY: Short Promotional Video, Corporate/Recruitment Videos, Social Media Package and more",
          "GRAPHIC DESIGN: Branding Package, Marketing and Advertising, Print Design and more",
          "Response time less than 24 hours"
        ]
      },
      "advanced": {
        "title": "2. Advanced Package",
        "prices": "20-30 hours/month (€1,500–€2,000/month)",
        "deliverables": "Deliverables:",
        "items": [
          "VIDEOGRAPHY: Promotional Video, Corporate/Recruitment Videos, Social Media Package and more",
          "MOTION GRAPHICS: Custom animations, light animations, sound design and more",
          "GRAPHIC DESIGN: Branding Package, Marketing and Advertising, Print Design and more",
          "UI/UX DESIGN: Strategy, Website Graphics and Layouts, User Interface (UI) Design and more",
          "Response time less than 24 hours"
        ]
      },
      "elite": {
        "title": "3. Elite Package",
        "prices": "40-65 hours/month (€3,000–€4,500/month)",
        "deliverables": "Deliverables:",
        "items": [
          "VIDEOGRAPHY: Promotional Video, Corporate/Recruitment Videos, Social Media Package and more",
          "MOTION GRAPHICS: Custom animations, light animations, sound design and more",
          "GRAPHIC DESIGN: Branding Package, Marketing and Advertising, Print Design and more",
          "UI/UX DESIGN: Strategy, Website Graphics and Layouts, User Interface (UI) Design and more",
          "DEVELOPMENT: Simple Landing Page Development, Website Maintenance, Complete Website Redesign and more",
          "Response time less than 8 hours"
        ]
      }
    }
  },
  "perProject": {
    "intro": "Flexibility and tailored solutions for specific goals.",
    "video": {
      "title": "VIDEO",
      "items": {
        "promo": {
          "title": "Short Promotional Video",
          "price": "Price Range: €500–€1,000",
          "features": [
            "Script assistance.",
            "Filming or editing of provided footage.",
            "Basic animations or captions."
          ]
        },
        "corporate": {
          "title": "Corporate/Recruitment Videos",
          "price": "Price Range: €1,200–€2,500",
          "features": [
            "On-site shooting (1 day).",
            "Advanced editing and motion graphics.",
            "Custom branding and voiceover options."
          ]
        },
        "social": {
          "title": "Social Media Package (3 short videos)",
          "price": "Price Range: €500–€1,000",
          "features": [
            "Short, engaging content tailored for platforms like Instagram, LinkedIn, or TikTok.",
            "Fast turnaround for trend-based marketing."
          ]
        }
      }
    },
    "graphicDesign": {
      "title": "GRAPHIC DESIGN",
      "items": {
        "branding": {
          "title": "Branding Package",
          "price": "Price Range: €1,000–€1,500",
          "features": ["Logo design", "Business cards", "2 marketing materials"]
        },
        "marketing": {
          "title": "Marketing and Advertising",
          "price": "Price: €70/hour",
          "features": [
            "Brochure and Flyer Design",
            "Poster Design",
            "Banner Ads (Web and Print)",
            "Social Media Graphics",
            "Email Newsletter Design"
          ]
        },
        "webDigital": {
          "title": "Web and Digital Design",
          "price": "Price: €70/hour",
          "features": [
            "Website Graphics and Layouts",
            "User Interface (UI) Design",
            "App Icon Design",
            "Infographics",
            "E-book Design"
          ]
        },
        "print": {
          "title": "Print Design",
          "price": "Price: €70/hour",
          "features": [
            "Magazine and Newspaper Layouts",
            "Book Cover Design",
            "Invitations and Event Cards",
            "Signage and Billboards",
            "Custom Illustrations for Print"
          ]
        },
        "visualContent": {
          "title": "Visual Content Creation",
          "price": "Price: €70/hour",
          "features": [
            "Presentation Design (e.g., PowerPoint, Keynote)",
            "Custom Illustrations",
            "Icon Design",
            "Social Media Graphics",
            "Motion Graphics (e.g., animated logos)"
          ]
        },
        "specialized": {
          "title": "Specialized Services",
          "price": "Price: €70/hour",
          "features": [
            "Product Mockup",
            "Trade Show Booth Graphics",
            "Menu Design (e.g., for restaurants)",
            "T-shirt and Apparel Design",
            "Vehicle Wraps"
          ]
        }
      }
    },
    "development": {
      "title": "DEVELOPMENT",
      "items": {
        "simpleLandingPage": {
          "title": "Simple Landing Page Development",
          "price": "Price Range: €1,000–€2,000",
          "features": ["Mobile-friendly design, basic SEO, and fast delivery"]
        },
        "websiteMaintenance": {
          "title": "Website Maintenance",
          "price": "Price: €50–€100/hour",
          "features": ["For minor updates or fixes on an as-needed basis."]
        },
        "completeWebsiteRedesign": {
          "title": "Complete Website Redesign",
          "price": "Price: €3,000+",
          "features": [
            "Full overhaul of an existing website, including structure, branding, and SEO optimization."
          ]
        }
      }
    }
  },
  "modal": {
    "title": "-50% FOR THE FIRST CORPORATE OR RECRUITMENT VIDEOS",
    "location": "*FILMING ONLY POSSIBLE IN MUNICH, GERMANY (+ 100KM).",
    "howItWorks": {
      "title": "How does this work?",
      "description": "Thank you for considering my services. After a brief discussion, you can choose a company story video or a recruitment video(~30 seconds). We establish a date and then I film and edit the video.",
      "callout": "Perfect for social media and marketing — this is your chance to see the quality I bring to every frame. No strings attached!"
    },
    "form": {
      "fullName": {
        "placeholder": "Full Name"
      },
      "email": {
        "placeholder": "Email"
      },
      "submit": "I want to try it",
      "cancel": "Cancel"
    }
  }
}
